export default __webpack_public_path__ + "static/media/announcement_security.84d8e178.jpeg";